// An order's page as a real link (<a href>), so ⌘/Ctrl-click, middle-click
// and "Open in new tab" work, while a plain click still opens it in place
// through the router (no page reload).

/** The order page's address. */
export const orderHref = (id) => `/app/orders/${id}`;

/** A plain left click — no ⌘, Ctrl, Shift or Alt. Anything else is the browser's to open. */
export const isPlainClick = (e) => (e.button === undefined || e.button === 0)
  && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

/**
 * onClick for an order's <a href>: a plain click opens it here (`open(id)`),
 * anything else is left to the browser. Either way the click stops at the
 * link, so a card or row around it doesn't open the order a second time.
 */
export const linkClick = (id, open) => (e) => {
  e.stopPropagation();
  if (!isPlainClick(e)) return;
  e.preventDefault();
  open(id);
};

/**
 * onClick for something around the link (a card, a row): a plain click opens
 * the order here, a ⌘/Ctrl-click in a new tab, as the link itself would.
 */
export const openOrderFrom = (e, id, open) => {
  if (isPlainClick(e)) open(id);
  else window.open(orderHref(id), '_blank', 'noopener');
};
